import React from "react";


const dialogOnMouseDown = (e) => {    

    e.currentTarget .setAttribute('atr-move',1); 

    var et = window.event;


    var xNow  =  e.currentTarget .getBoundingClientRect().left;
    var yNow  =  e.currentTarget .getBoundingClientRect().top;

    e.currentTarget .setAttribute('atr-cursor-x',et.clientX - xNow ); 
    e.currentTarget .setAttribute('atr-cursor-y',et.clientY - yNow); 
}

const dialogOnMouseUp = (e) => {    
    e.currentTarget .setAttribute('atr-move',0); 
}


const dialogOnMouseMove = (e) => {

    var status =  e.currentTarget .getAttribute('atr-move');  // 0 - nic, 1 - down

    var et = window.event;
    var xCursor = et.clientX;
    var yCursor = et.clientY;


    var xStart =  e.currentTarget .getAttribute('atr-cursor-x'); 
    var yStart =  e.currentTarget .getAttribute('atr-cursor-y'); 



    if(status != 1) return;

    var diffX =  xCursor - xStart;
    var diffY =  yCursor - yStart;

 

    e.currentTarget.style.position = 'fixed';
    e.currentTarget.style.left =   parseInt(  diffX) + "px";
    e.currentTarget.style.top =    parseInt( diffY) + "px";
 
    

    return false;
}

const AppContext = {
    lastKeyDown : 0,
    timeoutId: null,

    dialogOnMouseDown: dialogOnMouseDown,
    dialogOnMouseUp: dialogOnMouseUp,
    dialogOnMouseMove: dialogOnMouseMove,
};




export default AppContext;